// LIBRARIES
import styled from "styled-components";

//MISC;
import {
  SIZE,
  DEVICE_TYPE,
  COLORS,
  BORDER_RADIUS,
  MARGIN,
} from "constants/variables";

export const LegislationWindowContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const FirstSection = styled.div`
  background-color: ${COLORS.FaluRed};
  height: fit-content;
  border-bottom-left-radius: ${BORDER_RADIUS.radius24};
  border-bottom-right-radius: ${BORDER_RADIUS.radius24};
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: ${SIZE.max180};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    gap: ${SIZE.max100};
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 0;
  }
  svg {
    position: absolute;
    right: 0;
    bottom: -5px;
    transform: rotate(270deg);
    height: ${SIZE.max280};
    width: auto;
    @media (max-width: ${DEVICE_TYPE.mobile}) {
      display: none;
    }
  }
`;
export const TextContentWrapper = styled.div`
  padding: ${SIZE.max180} 0 ${SIZE.max120} ${SIZE.max80};
  width: 45%;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 100%;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: ${SIZE.max180} ${SIZE.max80} 0 ${SIZE.max80};
  }
`;

export const Description = styled.div`
  margin-top: ${SIZE.max24};
`;

export const IlustrationWrapper = styled.img`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${SIZE.max330};
  margin: ${SIZE.max40};
  z-index: 5;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    height: ${SIZE.max320};
    margin: ${SIZE.max80};
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: 100%;
    padding: ${SIZE.max80};
    margin: 0;
    height: auto;
  }
`;

export const StatisticSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${SIZE.max160} ${SIZE.max160} ${SIZE.fix42} ${SIZE.max160};
  gap: ${SIZE.max60};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    padding: ${SIZE.max160} ${SIZE.max80} ${SIZE.max160} ${SIZE.max80};
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: ${SIZE.max160} ${MARGIN.fix24} ${SIZE.max160} ${MARGIN.fix24};
  }
`;

export const SectionTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: ${SIZE.max10};
  @media (max-width: ${DEVICE_TYPE.smallDevice}) {
    flex-direction: column;
  }
`;

export const CardContainer = styled.div`
width: 100%;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  @media (max-width: ${DEVICE_TYPE.smallDevice}) {
    grid-template-columns: repeat(1, 1fr);
  }
  gap: 24px;
`;
